"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _AlertText = _interopRequireDefault(require("../../../../domainless/feedback/AlertText"));
var _AlertBox = _interopRequireWildcard(require("../../../../domainless/feedback/AlertBox"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _PasswordInlineValidation = _interopRequireDefault(require("./PasswordInlineValidation"));
var _validator = _interopRequireDefault(require("../../../../../utils/validator"));
var _validationConstraints = require("./validationConstraints");
var _FormModule = _interopRequireDefault(require("./Form.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Form = props => {
  const {
    onSubmit,
    signupError,
    resetSignupError
  } = props;
  const [nickname, setNickname] = (0, _react.useState)("");
  const [email, setEmail] = (0, _react.useState)("");
  const [password, setPassword] = (0, _react.useState)("");
  const [validationErr, setValidationErr] = (0, _react.useState)("");
  const handleSubmit = e => {
    e.preventDefault();
    const isNotValid = (0, _validator.default)({
      nickname,
      email,
      password
    }, _validationConstraints.signupFormConstraints);
    if (isNotValid) {
      return setValidationErr(isNotValid[0]);
    }
    onSubmit(nickname, email, password);
  };
  const emailValidationMsg = () => {
    const isNotValid = (0, _validator.default)({
      email
    }, {
      email: _validationConstraints.signupFormConstraints.email
    });
    if (isNotValid && !(0, _isEmpty.default)(email)) {
      return isNotValid[0];
    }
    return null;
  };
  const handleNicknameChange = e => {
    setNickname(e.target.value);
    setValidationErr(undefined);
    resetSignupError && resetSignupError();
  };
  const handleEmailChange = e => {
    setEmail(e.target.value.toLowerCase());
    setValidationErr(undefined);
    resetSignupError && resetSignupError();
  };
  const handlePasswordChange = e => {
    setPassword(e.target.value);
    setValidationErr(undefined);
    resetSignupError && resetSignupError();
  };
  return /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    autoComplete: "off",
    className: _FormModule.default.signupForm
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    id: "outlined-user-name",
    label: "Username",
    className: _FormModule.default.textField,
    value: nickname,
    margin: "normal",
    variant: "outlined",
    onChange: handleNicknameChange
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: _FormModule.default.charLength
  }, nickname.length, "/20 char")), /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default.emailContainer
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    id: "outlined-email-input",
    label: "Email",
    className: _FormModule.default.textField,
    type: "email",
    name: "email",
    autoComplete: "email",
    margin: "normal",
    variant: "outlined",
    value: email,
    onChange: handleEmailChange
  }), /*#__PURE__*/_react.default.createElement(_AlertText.default, {
    type: _AlertBox.alertTypes.ERROR,
    message: emailValidationMsg()
  })), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    id: "outlined-password-input",
    label: "Password",
    className: _FormModule.default.textField,
    type: "password",
    autoComplete: "current-password",
    margin: "normal",
    variant: "outlined",
    value: password,
    onChange: handlePasswordChange
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default.passwordCriteriaContainer
  }, /*#__PURE__*/_react.default.createElement("p", null, "Include:"), /*#__PURE__*/_react.default.createElement(_PasswordInlineValidation.default, {
    password: password
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default.alertBoxContainer
  }, /*#__PURE__*/_react.default.createElement(_AlertBox.default, {
    message: signupError || validationErr
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    variant: "contained",
    children: "Create Account",
    onClick: handleSubmit,
    type: "submit"
  }));
};
Form.propTypes = {
  onSubmit: _propTypes.default.func,
  signupError: _propTypes.default.string,
  resetSignupError: _propTypes.default.func
};
var _default = exports.default = Form;